import { createConfig, http, type Config, type CreateConnectorFn } from 'wagmi'
import { injected } from 'wagmi/connectors/injected'
import { anvil, robinhoodChain } from '@algoboo/chain/chains'
import { env } from '../env'

/** One chain per environment: anvil for local and e2e builds (VITE_CHAIN_ID=31337), Robinhood Chain otherwise. */
const localChain = env.chainId === anvil.id

export const primaryChain = localChain ? anvil : robinhoodChain

export async function createWagmiConfig(): Promise<Config> {
  const connectors: CreateConnectorFn[] = [injected({ shimDisconnect: true })]
  if (env.walletConnectProjectId) {
    // loaded only when configured: the WalletConnect provider is large
    const { walletConnect } = await import('wagmi/connectors/walletConnect')
    connectors.push(walletConnect({ projectId: env.walletConnectProjectId, showQrModal: true, metadata: { name: 'algo.boo', description: 'Autonomous agents trading in the open', url: window.location.origin, icons: [`${window.location.origin}/favicon.svg`] } }))
  }
  // Branch per chain so `transports` is typed for exactly the configured chain (a computed key on the
  // `anvil | robinhoodChain` union widens to `number` and loses the per-chain record type).
  // Anvil reads go to its default 127.0.0.1:8545; the e2e harness forwards that to its own anvil
  // (apps/web/e2e/fixtures/wallet.ts `routeAnvilTransport`).
  return localChain
    ? createConfig({ chains: [anvil], connectors, transports: { [anvil.id]: http() }, ssr: false })
    : createConfig({ chains: [robinhoodChain], connectors, transports: { [robinhoodChain.id]: http() }, ssr: false })
}
